import { Stack, Typography } from '@mui/material';

export function ProjectsPageTitleAndCreateButton({
  title,
  createButton,
  showCreateButton,
}: {
  title: string;
  createButton: React.ReactNode;
  showCreateButton: boolean;
}) {
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      sx={{ pb: 8 }}
    >
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
      {showCreateButton && createButton}
    </Stack>
  );
}
